import { selectChangeMessageForVideoAttachments } from '@UI/aside/asideVideo/asideVideoSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectVideoNode } from '@newStore/documentUI/transformContent/videoSelectors';
import { selectIsVideoLinkValidRule } from '@newStore/validation/validationRules/videoLinkRules';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';

const VIDEO: BuildingBlockNodeConfig = {
  nodeSelector: selectVideoNode,
  information: {
    single: 'Video',
    plural: "Video's",
    ribonIcon: require('../../../../img/buildingBlocks/VIDEO.svg'),
  },
  buildingBlocks: [],
  edit: [
    {
      component: 'video',
      reactComponent: 'AsideVideo',
      label: 'Video',
      property: 'attachments',
      required: RequiredType.ERROR,
      options: { type: ContentType.VIDEO },
      asideChangeMessageSelector: selectChangeMessageForVideoAttachments,
      validations: [selectIsVideoLinkValidRule],
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default VIDEO;
